var indentation_default = {
  "indentZero": "jTM--",
  "indentOne": "_967xj",
  "indentTwo": "hXNbW",
  "indentThree": "izimV",
  "indentFour": "D2XCk",
  "indentFive": "XIylQ",
  "indentSix": "a0M1x"
};
export {
  indentation_default as default
};
//# sourceMappingURL=indentation-scss.js.map
